import { useState } from 'react';

interface AdminItem {
  id?: string;
  name?: string;
  email?: string;
  status?: string;
  role?: string;
  department?: string;
  partner?: string;
  subscription_plan?: string;
  subscription_status?: string;
  projects?: number;
  budget?: number;
  description?: string;
  progress?: number;
  [key: string]: unknown;
}

export const useAdminModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedItem, setSelectedItem] = useState<AdminItem | null>(null);

  const openModal = (type: string, item: AdminItem | null = null) => {
    setModalType(type);
    setSelectedItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalType('');
    setSelectedItem(null);
  };

  const handleEdit = (item: AdminItem) => {
    openModal(modalType, item);
  };

  const handleCreate = () => {
    openModal(modalType, null);
  };

  return {
    showModal,
    modalType,
    selectedItem,
    openModal,
    closeModal,
    handleEdit,
    handleCreate
  };
};

export default useAdminModal;
